import React from "react";

function Color_HEX() {
  return (
    <div>
      <h1>Color_HEX Component</h1>
      <p>This is the Color HEX tutorial page content.</p>
    </div>
  );
}

export default Color_HEX;
